export default [
  {
    path: "/cryptoConfigurations/cashoutMethods",
    component: () => import(/* webpackChunkName: "layout" */ "../layout"),

    children: [
      {
        path: ":id",
        props: true,
        name: "crypto.cashoutMethods.show",
        component: () => import(/* webpackChunkName: "crypto.cashoutMethods" */ "./show.vue"),
      },
    ],
  },
];
